import { Accordion } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

import { TradePlanDetailType } from '@/cip/_openapi/portfolio-optimizer';
import { moneyCol, numberCol, textCol } from '@/cip/widgets/Table/columnHelpers/colDef';

import { DetailsBlock } from './DetailsBlock';
import { ConvictionDebug, TradeDetailRecord } from './tradeDetailsModel';

export const ConvictionDetails = ({
    tradePlanDetails,
}: {
    tradePlanDetails: Partial<Record<TradePlanDetailType, TradeDetailRecord>>;
}) => {
    const debug = tradePlanDetails[TradePlanDetailType.CONVICTION_DEBUG]?.detailJson;

    return (
        <Accordion allowMultiple>
            {debug && (
                <DetailsBlock
                    data={debug as ConvictionDebug[]}
                    columns={debugColumns}
                    columnSettingsKey="convictionDetailsDebug"
                    title="Debug"
                />
            )}
        </Accordion>
    );
};

const debugColumnHelper = createColumnHelper<ConvictionDebug>();
const debugColumns = [
    debugColumnHelper.accessor('sId', textCol({ id: 'sId' })),
    debugColumnHelper.accessor('targetWeight', numberCol({ id: 'targetWeight' })),
    debugColumnHelper.accessor('nav', moneyCol({ id: 'nav' })),
    debugColumnHelper.accessor('targetExposure', moneyCol({ id: 'targetExposure' })),
    debugColumnHelper.accessor('quotePrice', moneyCol({ id: 'quotePrice' })),
    debugColumnHelper.accessor('targetQuantity', numberCol({ id: 'targetQuantity' })),
    debugColumnHelper.accessor('currentQuantity', numberCol({ id: 'currentQuantity' })),
    debugColumnHelper.accessor('tradeQuantity', numberCol({ id: 'tradeQuantity' })),
];
